
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/payment-initiation/virtual-accounts/add-to-app",
      function () {
        return require("private-next-pages/docs/payment-initiation/virtual-accounts/add-to-app.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/payment-initiation/virtual-accounts/add-to-app"])
      });
    }
  